import { useEffect, useState } from 'react'
import { getDocument } from 'services/firestore'

const useGetCustomerMockups = (customer) => {
  const [mockups, setMockups] = useState([])
  const [loading, setLoading] = useState(!!customer?.mockupIds?.length)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      const promises = customer.mockupIds.map((mockup) =>
        getDocument('mockups', mockup)
      )
      const data = await Promise.all(promises)
      setMockups(data)
      setLoading(false)
    }

    customer?.mockupIds?.length && fetchData()
  }, [customer])

  return [mockups, loading]
}

export default useGetCustomerMockups
